import script from "./GalleryHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryHeader.vue?vue&type=script&setup=true&lang=js"

import "./GalleryHeader.vue?vue&type=style&index=0&id=c1f90350&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1f90350"]])

export default __exports__